module.exports = __webpack_public_path__ + "img/purple.fe4da277.webp";